import React, { FC } from 'react';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { DEFAULT_REQUEST_TYPE_FILTER_SELECTED } from '../../constants/filters';
import { TABLE_COLUMN_KEYS } from '../../constants/table';

interface Props {
  requestTypeSelectedOption: string;
  handleFilter: (type: string, filterBy: string) => void;
  requestTypeFilterOptions: string[];
}

export const RequestTypeFilter: FC<Props> = ({ requestTypeSelectedOption, handleFilter, requestTypeFilterOptions }) => {
  return (
    <div className="request-type-filter" data-testid="request-type-filter">
      <DropdownMenu
        testId="request-type-dropdown"
        trigger={!requestTypeSelectedOption ? DEFAULT_REQUEST_TYPE_FILTER_SELECTED : requestTypeSelectedOption}
        triggerType="button"
      >
        <DropdownItemGroup>
          <DropdownItem data-testid="All request type" onClick={() => handleFilter(TABLE_COLUMN_KEYS.REQUEST_TYPE, '')}>
            {DEFAULT_REQUEST_TYPE_FILTER_SELECTED}
          </DropdownItem>
          {requestTypeFilterOptions.map((value) => (
            <DropdownItem
              data-testid={`Request type ${value}`}
              onClick={() => handleFilter(TABLE_COLUMN_KEYS.REQUEST_TYPE, value)}
              key={value}
            >
              {value}
            </DropdownItem>
          ))}
        </DropdownItemGroup>
      </DropdownMenu>
    </div>
  );
};
